
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {AppUiModule} from "../ui";
import { UIRouterModule } from '@uirouter/angular';

import { LoginState ,RestoreState, SignUpState } from './states';
import {SignUpPageComponent} from "./signup-page";
import {LoginPageComponent} from "./login-page";
import {RestorePageComponent} from "./restore-page";
import { TextMaskModule } from 'angular2-text-mask';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
let STATES = [ LoginState, SignUpState, RestoreState];
/** The NgModule for the SSO feature */
@NgModule({
    imports: [
        CommonModule,

        UIRouterModule.forChild({ states: STATES }),
        AppUiModule,
        FormsModule,
        ReactiveFormsModule,
        TextMaskModule,
        RecaptchaModule,
        RecaptchaFormsModule

    ],
    declarations: [
        SignUpPageComponent,
        LoginPageComponent,
        RestorePageComponent
    ],
    exports: [

    ]
})
class SsoModule {}

export {SsoModule};